<template>
    <div class="tw:bg-white tw:rounded-xl">
        <BaseTable
            :columns="columns"
            :data="frecuencias"
            :skeleton="loading"
            :skeleton-rows="5"
            empty-text="No hay frecuencias disponibles"
            :default-col-width="defaultColWidth"
        >
            <!-- Skeleton headers -->
            <template #skeleton-header-cantidad>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>
            <template #skeleton-header-frecuencia>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-20"></div>
            </template>
            <template #skeleton-header-opciones>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-28 tw:mx-auto"></div>
            </template>

            <!-- Skeleton rows -->
            <template #skeleton-cantidad>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-frecuencia>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-28"></div>
            </template>
            <template #skeleton-opciones>
                <div class="tw:h-9 tw:w-28 tw:bg-gray-200 tw:rounded tw:mx-auto"></div>
            </template>

            <template #cell-cantidad="{ row }">
                <span class="tw:text-sm tw:text-gray-700">{{ row.cantidad }}</span>
            </template>

            <template #cell-frecuencia="{ row }">
                <span class="tw:text-sm tw:text-gray-700">{{ row.frecuencia }}</span>
            </template>

            <template #cell-opciones="{ row, index }">
                <OpcionesDropdownTableComponent
                    :last-index="frecuencias.length > 3 && index >= frecuencias.length - 3"
                    :options="[
                        { type: 'action', action: () => showModal('editar-' + row.id), label: 'Editar', icon: 'edit' },
                        { type: 'action', action: () => showModal('borrar-' + row.id), label: 'Borrar', icon: 'trash' }
                    ]"
                />
            </template>
        </BaseTable>

        <!-- Modales inline (vue-js-modal DOM presence required) -->
        <template v-for="item in frecuencias">
            <FrecuenciaEditModal
                :key="'editar-' + item.id"
                :name="'editar-' + item.id"
                :model-value="item"
                @save="(data) => handleEditSave(item.id, data)"
                @close="closeModal('editar-' + item.id)"
            />
            <FrecuenciaBorrarModal
                :key="'borrar-' + item.id"
                :name="'borrar-' + item.id"
                :frecuencia-label="item.frecuencia"
                @confirm="handleDelete(item.id)"
                @close="closeModal('borrar-' + item.id)"
            />
        </template>
    </div>
</template>

<script setup>
    import { getCurrentInstance } from 'vue'
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue'
    import OpcionesDropdownTableComponent from '@/modules/admin/ui/OpcionesDropdownTableComponent.vue'
    import FrecuenciaEditModal from './FrecuenciaEditModal.vue'
    import FrecuenciaBorrarModal from './FrecuenciaBorrarModal.vue'

    const { proxy } = getCurrentInstance()

    defineProps({
        frecuencias: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        defaultColWidth: {
            type: String,
            default: '95px'
        }
    })

    const emit = defineEmits(['delete', 'edit-save'])

    const columns = [
        { key: 'cantidad', label: 'Cantidad', centered: true},
        { key: 'frecuencia', label: 'Frecuencia', centered: true },
        { key: 'opciones', label: 'Acciones', centered: true, class: 'tw:w-28' }
    ]

    function showModal(name) {
        proxy?.$modal?.show(name)
    }

    function closeModal(name) {
        proxy?.$modal?.hide(name)
    }

    function handleDelete(id) {
        closeModal('borrar-' + id)
        emit('delete', id)
    }

    function handleEditSave(id, formData) {
        closeModal('editar-' + id)
        emit('edit-save', { ...formData, id })
    }
</script>
